import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';

import { CloneWorksListTemplate } from 'works/legacy/graphql/works-list-template';
import { createMessage } from 'works/legacy/lib/message-helper';
import { LoadingState, Modal } from '@common/components';

export default function CloneList({
  children,
  worksListTemplateId,
  worksListTemplateName,
  onSuccess,
}) {
  const [cloneList, { loading }] = useMutation(CloneWorksListTemplate);

  const handleClone = () => {
    cloneList({
      variables: {
        worksListTemplateId: worksListTemplateId,
      },
    })
      .then(({ data }) => {
        if (!data.cloneWorksListTemplate) return;

        if (data.cloneWorksListTemplate.worksListTemplate) {
          createMessage(
            'success',
            'Compliance List Template has been created!'
          );
          onSuccess();
        } else {
          createMessage(
            'error',
            'Failed to duplicate Compliance List Template. Please try again or contact your hiring partner.'
          );
        }
      })
      .catch(() => {
        createMessage(
          'error',
          'Failed to duplicate Compliance List Template. Please try again or contact your hiring partner.'
        );
      });
  };

  const handleClick = () => {
    Modal.confirm({
      title: 'Template Duplication Confirmation',
      content: (
        <>
          Are you sure you want to duplicate the &quot;{worksListTemplateName}
          &quot; template and all its items?
        </>
      ),
      okText: 'Yes',
      cancelText: 'No',
      onOk: handleClone,
    });
  };

  return loading ? (
    <LoadingState size="md" />
  ) : (
    <a className="clone-works-list-template-icon" onClick={handleClick}>
      {children}
    </a>
  );
}

CloneList.propTypes = {
  children: PropTypes.node.isRequired,
  worksListTemplateId: PropTypes.string.isRequired,
  worksListTemplateName: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
};
